import { createContext, Dispatch } from 'react';

export interface User {
  // id: string;
  name: string;
  // email: string;
}

export interface AuthContextType {
  signed: boolean;
  user: string | null;
  token: string | null;
  baseUrl: string | undefined;
  autoridade: string[] | undefined
  signIn: (user: string, token: string, autoridades: string[]) => void;
  signOut: () => void;
  setBaseUrl: Dispatch<string | undefined>;
}

export const AuthContext = createContext<AuthContextType>(
  {} as AuthContextType
);
